import { render, staticRenderFns } from "./1007_行相等的最少多米诺旋转.md?vue&type=template&id=006e2ac0&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports